export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10207.187e04d1.jpg";